import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AccountService } from '../../../../store/services/account.service';

type UnsubsStatus = 'loading' | 'success' | 'error';

@Component({
  selector: 'app-unsubs',
  templateUrl: './unsubs.component.html',
  styleUrls: ['./unsubs.component.scss'],
})
export class UnsubsComponent implements OnInit, OnDestroy {
  static readonly SUCCESS_MESSAGE =
    "You've been successfully unsubscribed. You will no longer receive campaign emails from this sender.";
  static readonly MISSING_CODE_MESSAGE =
    'This unsubscribe link is invalid or incomplete. Please use the link from your email.';
  static readonly DEFAULT_ERROR_MESSAGE =
    'We could not process your unsubscribe request. Please try again later or reply to the email to ask to be removed.';

  status: UnsubsStatus = 'loading';
  message = '';

  private readonly destroy$ = new Subject<void>();

  constructor(
    private readonly activatedRoute: ActivatedRoute,
    private readonly accountService: AccountService,
  ) {}

  ngOnInit(): void {
    this.activatedRoute.queryParams
      .pipe(takeUntil(this.destroy$))
      .subscribe((params: { secure_code?: string }) => {
        const secureCode = params.secure_code?.trim();
        if (!secureCode) {
          this.status = 'error';
          this.message = UnsubsComponent.MISSING_CODE_MESSAGE;
          return;
        }

        this.status = 'loading';
        this.accountService
          .unsubscribe(secureCode)
          .pipe(takeUntil(this.destroy$))
          .subscribe(
            response => {
              if (response) {
                this.status = 'success';
                this.message = UnsubsComponent.SUCCESS_MESSAGE;
              } else {
                this.status = 'error';
                this.message = UnsubsComponent.DEFAULT_ERROR_MESSAGE;
              }
            },
            error => {
              this.status = 'error';
              this.message =
                error?.error?.message ||
                error?.error?.error ||
                error?.error ||
                UnsubsComponent.DEFAULT_ERROR_MESSAGE;
              if (typeof this.message !== 'string') {
                this.message = UnsubsComponent.DEFAULT_ERROR_MESSAGE;
              }
            },
          );
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
